export enum ClerkOrganizationRole {
  OrgAdmin = 'org:admin',
  OrgMember = 'org:member',
}

export enum PortfolioRole {
  PortfolioManager = 'portfolio_manager',
  User = 'user',
}

export enum ProductRole {
  ProductManager = 'product_manager',
  Collaborator = 'collaborator',
  Observer = 'observer',
}

export type OrganizationMembership = {
  organizationId: string
  role: ClerkOrganizationRole
  isDesignatedPortfolioManager: boolean
}

export type PortfolioMembership = {
  portfolioId: string
  organizationId: string
  role: PortfolioRole
}

export type ProductMembership = {
  productId: string
  portfolioId: string
  organizationId: string
  role: ProductRole
}

export type UserContext = {
  organizationUserId: string
  organizationMemberships: OrganizationMembership[]
  portfolioMemberships: PortfolioMembership[]
  productMemberships: ProductMembership[]
}

export enum ActionType {
  EditOrganizationSettings = 'edit_organization_settings',
  InviteToOrganization = 'invite_to_organization',
  CreatePortfolio = 'create_portfolio',
  AssignPortfolioMember = 'assign_portfolio_member',
  EditPortfolioContext = 'edit_portfolio_context',
  CreateProduct = 'create_product',
  EditProduct = 'edit_product',
  InviteToProduct = 'invite_to_product',
  AssignProductRole = 'assign_product_role',
  AccessStellaPortfolio = 'access_stella_portfolio',
  AccessStellaProduct = 'access_stella_product',
  TriggerStellaActionProduct = 'trigger_stella_action_product',
}

export type Action =
  | { type: ActionType.EditOrganizationSettings; organizationId: string }
  | { type: ActionType.InviteToOrganization; organizationId: string }
  | {
      type: ActionType.CreatePortfolio
      organizationId: string
      organizationHasPortfolio: boolean
    }
  | { type: ActionType.AssignPortfolioMember; portfolioId: string }
  | { type: ActionType.EditPortfolioContext; portfolioId: string }
  | { type: ActionType.CreateProduct; portfolioId: string }
  | { type: ActionType.EditProduct; productId: string; portfolioId: string }
  | {
      type: ActionType.InviteToProduct
      productId: string
      portfolioId: string
      isInviteeInPortfolio: boolean
    }
  | {
      type: ActionType.AssignProductRole
      productId: string
      portfolioId: string
      targetRole: ProductRole
    }
  | { type: ActionType.AccessStellaPortfolio; portfolioId: string }
  | {
      type: ActionType.AccessStellaProduct
      productId: string
      portfolioId: string
    }
  | {
      type: ActionType.TriggerStellaActionProduct
      productId: string
      portfolioId: string
    }

export enum DenialReason {
  NotAuthenticated = 'not_authenticated',
  NotOrgAdmin = 'not_org_admin',
  NotPortfolioManager = 'not_portfolio_manager',
  NotProductMember = 'not_product_member',
  ObserverReadonly = 'observer_readonly',
  PortfolioAlreadyExists = 'portfolio_already_exists',
  InviteeNotInPortfolio = 'invitee_not_in_portfolio',
  InsufficientRole = 'insufficient_role',
}

export enum RedirectHint {
  SignIn = 'sign_in',
  NoOrganization = 'no_organization',
  HoldingPage = 'holding_page',
}

export type PermissionDenial = {
  status: 403
  body: {
    error: 'permission_denied'
    action: ActionType
    reason: DenialReason
    redirect: RedirectHint
  }
}
